<div class="desktop-width-limiter detail-page page-padding">
  @if (!loading && !error && profile) {
  <div class="page-content">
    <div class="page-attributes">
      <div class="profile-image">
        <div class="banner-section">
          <img
            class="banner"
            [src]="profile.banner"
            onerror="this.src='/assets/images/fallback-banner.png';"
            [alt]="'Banner'"
          />
          <div class="image-section">
            <div class="user-image-holder">
              <img
                [src]="getProfilePicture()"
                onerror="this.src = '/assets/images/user.png';"
                class="user-image"
                [alt]="'Afbeelding reporter'"
              />
            </div>
            @if (!!profile.name && profile.name !== ' ') {
            <span class="username">{{ profile.name }}</span>
            } @if (!profile.name || profile.name === ' ') {
            <span class="username">{{ profile.userName }}</span>
            }
            <img
              class="reporter-logo"
              src="/assets/images/streapp-reporter-white-gold.png"
              [alt]="'StreApp Reporter'"
            />
          </div>
        </div>
      </div>
      <div class="info">
        <!-- About Me Section -->
        <div
          class="about-me-section-spacing col-12 col-sm-12 col-md-6 col-lg-7 col-xl-8"
        >
          <mat-card class="widget info-left">
            <div class="about-me">
              <h1 class="title">{{ "profile.about_me" | translate }}</h1>
              @if (profile.profile) {
              <span class="text">
                {{ profile.profile }}
              </span>
              } @if (!profile.profile) {
              <span class="text">
                {{ "profile.about_me_missing" | translate }}
              </span>
              }
            </div>

            <div class="badges">
              <h1 class="title">{{ "profile.my_badges"| translate }}</h1>
              <div class="badges-wrap">
                @for (subscriptionRole of subscriptionRoles; track $index) {
                  <img class="sub-image" [src]="`assets/images/sub_${subscriptionRole.toLowerCase()}.png`" [alt]="subscriptionRole + ' image'"/>
                }
                <img class="age-image" [src]="`assets/images/${profile.isUnderAge ? '18-' : '18+'}.png`" alt="user-age-image" />
              </div>
            </div>
          </mat-card>
        </div>
        <div class="info-right col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4">
          <!-- Geplaatste Streapps -->
          @if (profile.amountOfStreApps) {
          <div class="total-streapps-holder">
            <div class="total-streapps">
              <span class="number">{{ profile.amountOfStreApps }}</span>
              <span class="description">{{
                "profile.streapps_posted" | translate
              }}</span>
            </div>
          </div>
          }
          <div class="info-buttons row">
            <!-- Rapporteer gebruiker -->
            <profile-widget
              [iconName]="'warning'"
              [text]="'report.report_profile' | translate"
              [backgroundType]="'white'"
              (click)="isLoggedIn() ? openReportingDialog() : openLoginPrompt()"
              class="report-button col-6"
            />
            <!-- Deel profiel -->
            <profile-widget
              [iconName]="'share'"
              [text]="'profile.widgets.share' | translate"
              [backgroundType]="'white'"
              (click)="share()"
              class="share-button col-6"
            />
          </div>
        </div>
      </div>
      <div class="filter-reporter-group">
        <div class="filter-reporter">
          <button
            mat-button
            (click)="setFilter('showAll')"
            [class.selected]="currentFilter == 'showAll'"
          >
            {{ "filter.show_all" | translate }}
          </button>
        </div>
        @for (filter of availableEventTypes; track filter) {
        <div class="filter-reporter">
          <button
            mat-button
            (click)="setFilter(filter)"
            [class.selected]="currentFilter == filter"
          >
            {{ filter ? filter : "Onbekend" }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  } @if (!loadingEvents && !errorText && filteredEvents.length > 0) {
  <div class="row overview-items">
    @for (event of filteredEvents; track event) {
    <div
      class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 col-xxl-2 overview-item-alternate"
    >
      <overview-card-alternate-version
        [event]="event"
      ></overview-card-alternate-version>
    </div>
    }
    <div class="noMoreEvents">
      <span class="noMoreEventsLabel">{{
        "page.noMoreEvents" | translate
      }}</span>
    </div>
  </div>
  } @if (loading || loadingEvents) {
  <div class="loading">
    <mat-progress-spinner
      class="loading-spinner"
      [diameter]="75"
      mode="indeterminate"
      color="primary"
    >
    </mat-progress-spinner>
  </div>
  } @if (!loading && error) {
  <div class="errorText">
    {{ "page.error" | translate }}
  </div>
  }
</div>
